module.exports = {
  defaultLocaleKey: 'zh',
  locales: ['zh', 'en']
}
